import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { useLanguage } from '@context'
import { showApiErrorToast, showSuccessToast } from '@utils'
import { ACCOUNT_SECURITY_QUERY_KEY } from '../queries/useAccountSecurity'

/** Lets an account created through an event code choose its first password. */
export const useSetInitialPassword = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()
  return useMutation<void, Error, { newPassword: string }>({
    mutationFn: async (body) => {
      await api.put('/me/password', body)
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [ACCOUNT_SECURITY_QUERY_KEY] })
      showSuccessToast(t('createPassword.savedTitle'), t('createPassword.savedMessage'))
    },
    onError: (error) => showApiErrorToast(t, error),
  })
}
